import { useMemo } from "react";
import { forEach, orderBy, reduce } from "lodash";
const inspectCategory = (node) => {
  if (node.children && node.children.length) {
    const sumOfChildrenCounts = reduce(node.children, (r, n) => r + n.value, 0);
    node.vizSize = Math.max(
      0,
      ((node.value - sumOfChildrenCounts) / node.value) * node.size
    );
    forEach(node.children, (child) => {
      child.size =
        (child.value / Math.max(sumOfChildrenCounts, node.value)) * node.size;
      inspectCategory(child);
    });
  } else {
    node.vizSize = node.size;
  }
};

export function useComputedSeries(series) {
  return useMemo(() => {
    return {
      id: series.id,
      label: series.label,
      children: orderBy(
        forEach(series.children, (child) => {
          child.size = child.value;
          inspectCategory(child);
        }),
        "value",
        "desc"
      ),
    };
  }, [series]);
}
